import styled from 'styled-components'
import { Card, Flex, Text, Box, getPaletteColor } from 'pcln-design-system'

export const ProductWrapper = styled(Card)`
  height: 185px;
  width: 273px;
  flex: 1 0;
  background-color: ${getPaletteColor('background.lightest')};
  margin-right: 12px;
  ${props => props.theme.mediaQueries[0]} {
    margin-right: 15px;
  }
`

export const ProductFlexBorder = styled(Flex)`
  border-bottom: 1px solid rgba(89, 107, 125, 0.5);
`

export const ProductImage = styled(Box)<{ bgImage: string }>`
  flex: 1 0;
  width: 100px;
  background-image: url(${props => props.bgImage});
`

export const ProductTitle = styled(Text)`
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  hyphens: auto;
  display: -webkit-box;
  -moz-box-orient: vertical;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const PrimaryText = styled(Text)`
  font-size: 14px;
`

export const SecondaryText = styled(Text)`
  font-size: 12px;
`

export const StyledSup = styled.sup`
  font-size: 0.6em;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
  top: -0.5em;
`
